// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2vjYn","inputWrap":"Table_inputWrap__3ITBx","col":"Table_col__2O_N7","bmiTooltip":"Table_bmiTooltip__15fmK"};